export class RecaptchaService {

  getToken = (): Promise<string> => {
    return new Promise((resolve) => {
      grecaptcha.ready(() => {
        grecaptcha.execute(import.meta.env.VITE_RECAPTCHA_KEY, { action: 'submit' }).then(token => {
          resolve(token)
        })
      })
    })
  }

}